import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { IconPlus, IconMinus } from "@tabler/icons";
import { ReceiptApi } from "src/api/ReceiptApi";
import { useSnackBar } from "src/context/SnackBarContext";

function Header({ header, setHeader, bank, fetchReceipt, readOnly = false }) {
  const { showSnackbar } = useSnackBar();

  return (
    <div>
      <Box p={2} component={Paper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              fullWidth
              label="Receipt No"
              value={header.rec_no}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                style: { textAlign: "center" },
              }}
              onChange={(e) =>
                setHeader((prev) => ({ ...prev, rec_no: e.target.value }))
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (header.rec_no) {
                    fetchReceipt(Number(header.rec_no));
                  }
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      size="small"
                      onClick={() => {
                        const newRecNo = Math.max(
                          1,
                          Number(header.rec_no || 1) - 1,
                        );
                        setHeader((prev) => ({
                          ...prev,
                          rec_no: newRecNo,
                        }));
                        fetchReceipt(newRecNo);
                      }}
                    >
                      <IconMinus fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        const newRecNo = Math.max(
                          1,
                          Number(header.rec_no || 1) + 1,
                        );
                        setHeader((prev) => ({
                          ...prev,
                          rec_no: newRecNo,
                        }));
                        fetchReceipt(newRecNo);
                      }}
                    >
                      <IconPlus fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              fullWidth
              label="Search by Bill No"
              placeholder="Press Enter to search"
              value={header.bill_no || ""}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setHeader((prev) => ({ ...prev, bill_no: e.target.value }))
              }
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (header.bill_no) {
                    try {
                      const res = await ReceiptApi.getReceiptNoByBillNo({ bill_no: Number(header.bill_no) });
                      if (res?.success && res?.SiNo) {
                        setHeader((prev) => ({
                          ...prev,
                          rec_no: res.SiNo,
                        }));
                        fetchReceipt(res.SiNo);
                      } else {
                        showSnackbar("error", res?.message || "No receipt found for this Bill No");
                      }
                    } catch (err) {
                      showSnackbar("error", "Failed to search receipt");
                    }
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              type="date"
              value={header.date || ""}
              onChange={(e) =>
                setHeader((prev) => ({ ...prev, date: e.target.value }))
              }
              fullWidth
              label="Date"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

Header.propTypes = {
  bank: PropTypes.any,
  header: PropTypes.any,
  setHeader: PropTypes.any,
  fetchReceipt: PropTypes.any,
  readOnly: PropTypes.bool,
};

export default Header;
